module.exports = "<mat-error class=\"text-danger\" *ngIf=\"errorMessage !== null\">{{errorMessage}}</mat-error>\r\n"